import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ roles, children }) => {
  const { authenticated, roleId } = useAuth();
  const location = useLocation();

  if (!authenticated) {
    // Save the attempted URL
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // If specific roles are required and current role doesn't match any
  if (roles && roles.length > 0 && !roles.includes(roleId)) {
    return <Navigate to="/not-found" replace />;
  }

  return children;
};

export default ProtectedRoute;